<div class="text-center ion-padding">
    <div class="flex full-height">
        <div class="flex-vertical-center flex-center-vertical ion-padding-horizontal">
            <lib-svg-icon [size]="50" color="var(--ion-color-primary)" iconName="settings-outline"></lib-svg-icon>
            <h2 class="modal-title">New update available</h2>
            <ion-text class="modal-text">
                A new version of GuardFinder is available in the {{ storeText() }}. Please update the app to access the
                latest features.
            </ion-text>
        </div>
    </div>
</div>
